var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoleImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 5.8335C11.1507 5.8335 12.0832 6.766 12.0832 7.91683C12.0832 9.06766 11.1507 10.0002 9.99984 10.0002C8.849 10.0002 7.9165 9.06766 7.9165 7.91683C7.9165 6.766 8.849 5.8335 9.99984 5.8335",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.3335C13.6408 13.0593 13.4717 12.8127 13.255 12.6118V12.6118C12.8892 12.2718 12.41 12.0835 11.91 12.0835C11.0767 12.0835 8.92333 12.0835 8.09 12.0835C7.59 12.0835 7.11167 12.2727 6.745 12.6118V12.6118C6.52833 12.8127 6.35917 13.0593 6.25 13.3335",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74992 17.3876C6.49076 17.0076 4.57576 15.6226 3.48242 13.7026",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29167 5.1416C3.17667 6.45077 2.5 8.14493 2.5 9.99993C2.5 10.4624 2.54833 10.9133 2.62833 11.3533",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.3876C13.5092 17.0076 15.4242 15.6226 16.5175 13.7026",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7918 3.53667C12.6785 2.88167 11.3852 2.5 10.0002 2.5C8.61516 2.5 7.32183 2.88167 6.2085 3.53667",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7085 5.1416C16.8235 6.45077 17.5002 8.14493 17.5002 9.99993C17.5002 10.4624 17.4518 10.9133 17.3718 11.3533",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleImage);
export default __webpack_public_path__ + "static/media/RoleImage.a6ff99fcaa4c9ed118fa5bf7afa560bf.svg";
export { ForwardRef as ReactComponent };